import { render, staticRenderFns } from "./spotStock.vue?vue&type=template&id=f95b9e72&scoped=true"
import script from "./spotStock.vue?vue&type=script&lang=js"
export * from "./spotStock.vue?vue&type=script&lang=js"
import style0 from "./spotStock.vue?vue&type=style&index=0&id=f95b9e72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95b9e72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f95b9e72')) {
      api.createRecord('f95b9e72', component.options)
    } else {
      api.reload('f95b9e72', component.options)
    }
    module.hot.accept("./spotStock.vue?vue&type=template&id=f95b9e72&scoped=true", function () {
      api.rerender('f95b9e72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/spotStock.vue"
export default component.exports